import React from 'react';
import { resolveImg } from './shared';

const ListingDetailPanel = ({ listing, testIdPrefix = '' }) => (
  <div className="mt-4 pt-4 border-t border-slate-100" data-testid={`detail-panel-${testIdPrefix}${listing.id}`}>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
      <div className="bg-slate-50 rounded-xl p-3">
        <p className="text-xs text-slate-500">Price</p>
        <p className="font-bold text-lg text-blue-600">
          {listing.price >= 10000000 ? `${(listing.price / 10000000).toFixed(2)} Cr` : listing.price >= 100000 ? `${(listing.price / 100000).toFixed(2)} L` : listing.price?.toLocaleString()}
          {listing.listing_type === 'rent' && <span className="text-xs font-normal text-slate-500">/mo</span>}
        </p>
      </div>
      <div className="bg-slate-50 rounded-xl p-3">
        <p className="text-xs text-slate-500">Size</p>
        <p className="font-semibold">{listing.size || (listing.size_sqft ? `${listing.size_sqft} sq.ft` : 'N/A')}</p>
      </div>
      {listing.land_size && (
        <div className="bg-slate-50 rounded-xl p-3">
          <p className="text-xs text-slate-500">Land Area</p>
          <p className="font-semibold">{listing.land_size}</p>
        </div>
      )}
      {listing.bedrooms && (
        <div className="bg-slate-50 rounded-xl p-3">
          <p className="text-xs text-slate-500">Bedrooms</p>
          <p className="font-semibold">{listing.bedrooms} BHK</p>
        </div>
      )}
      <div className="bg-slate-50 rounded-xl p-3">
        <p className="text-xs text-slate-500">Status</p>
        <p className="font-semibold capitalize">{listing.property_status === 'off_plan' ? 'Off Plan' : listing.property_status || 'Ready'}</p>
      </div>
    </div>
    <div className="mb-4">
      <p className="text-sm font-medium text-slate-700 mb-1">Description</p>
      <p className="text-sm text-slate-600 whitespace-pre-line">{listing.description}</p>
    </div>
    {listing.amenities && listing.amenities.length > 0 && (
      <div className="mb-4">
        <p className="text-sm font-medium text-slate-700 mb-2">Amenities</p>
        <div className="flex flex-wrap gap-2">
          {listing.amenities.map((a, i) => (
            <span key={i} className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">{a}</span>
          ))}
        </div>
      </div>
    )}
    <div className="mb-4 grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm font-medium text-slate-700 mb-1">Seller Info</p>
        <p className="text-sm text-slate-600">{listing.seller_name} ({listing.seller_type})</p>
        <p className="text-sm text-slate-500">{listing.seller_phone}</p>
        {listing.seller_email && <p className="text-sm text-slate-500">{listing.seller_email}</p>}
      </div>
      {listing.rera_number && (
        <div>
          <p className="text-sm font-medium text-slate-700 mb-1">RERA Number</p>
          <p className="text-sm text-slate-600">{listing.rera_number}</p>
        </div>
      )}
    </div>
    {listing.images && listing.images.length > 0 && (
      <div>
        <p className="text-sm font-medium text-slate-700 mb-2">All Images ({listing.images.length})</p>
        <div className="grid grid-cols-4 gap-3">
          {listing.images.map((img, i) => (
            <div key={i} className="rounded-lg overflow-hidden h-28 bg-slate-100">
              <img src={resolveImg(img)} alt={`${listing.title} ${i + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

export default ListingDetailPanel;
